import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import moment from 'moment'
import View from './View'
import { getCurrentUser } from '../../services/auth'
import { colors } from '../Colors'
import baby from '../../img/bebe-sucesso-agendamento.png'
import VejaTambem from '../../components/VejaTambem'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  h2 {
    font-size: 30px !important;
    text-transform: capitalize;
    color: #fa7272;
    background: none;
    text-align: left;
    span {
      font-size: 16px;
      display: block;
      font-weight: normal;
    }
  }
  .pageHeader {
    margin: auto;
    width: 100%;
    display: block;
  }

  button.next {
    margin-left: 20px;
  }

  .sucesso {
    display: flex;
    justify-content: space-between;
    width: 900px;
    margin: auto;
    background-image: url(${baby});
    background-position: 257px center;
    background-repeat: no-repeat;
    padding: 2em 0;
    min-height: 354px;
    align-items: center;
    padding: 2em 0;
    .col1 {
      width: 50%;
      span {
        color: ${colors.vermelho};
        display: block;
      }
    }
  }
`

const Sucesso = () => {
  const { name, email } = getCurrentUser()

  return (
    <Container>
      <View>
        <section className="sucesso">
          <div className="col1">
            <h2>Confirmado, {name}</h2>
            <p>
              Enviamos para o e-mail
              <span>{email} </span>
              os dados da sua visita, aguardamos você.
            </p>
            <button
              type="button"
              onClick={() => navigate('/agendamento-de-visitas/horarios')}
              className="button prev"
            >
              Alterar a visita
            </button>
            <button
              type="button"
              onClick={() => navigate('/')}
              className="button next"
            >
              Ir para home
            </button>
          </div>
        </section>
      </View>
      <VejaTambem />
    </Container>
  )
}

export default Sucesso
